import { z } from 'zod';

/**
 * Base RSVP schema without refinements
 * Used for extending to create the record schema
 */
const rsvpBaseSchema = z.object({
  name: z.string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must not exceed 100 characters')
    .trim(),

  email: z.string()
    .email('Please enter a valid email address')
    .toLowerCase()
    .trim(),

  attending: z.boolean({
    required_error: 'Please let us know if you can attend',
  }),

  guestCount: z.number()
    .int('Guest count must be a whole number')
    .min(0, 'Guest count cannot be negative')
    .max(10, 'Maximum 10 guests allowed'),

  dietaryRestrictions: z.string()
    .max(500, 'Dietary restrictions must not exceed 500 characters')
    .trim()
    .optional()
    .or(z.literal('')),
});

/**
 * RSVP form validation schema
 * Used by both frontend (React Hook Form) and backend (API validation)
 */
export const rsvpFormSchema = rsvpBaseSchema.refine(
  (data) => {
    // If attending, guest count must be at least 1
    if (data.attending && data.guestCount < 1) {
      return false;
    }
    return true;
  },
  {
    message: 'At least 1 guest is required when attending',
    path: ['guestCount'],
  }
);

/**
 * RSVP record schema (stored in KV)
 * Extends the base schema with additional metadata
 */
export const rsvpRecordSchema = rsvpBaseSchema.extend({
  id: z.string().uuid(),
  submittedAt: z.string().datetime(),
  ipAddress: z.string().optional(),
});

/**
 * API response schemas
 */
export const rsvpSuccessResponseSchema = z.object({
  success: z.literal(true),
  message: z.string(),
  data: z.object({
    id: z.string().uuid(),
    name: z.string(),
    attending: z.boolean(),
    guestCount: z.number(),
  }),
});

export const rsvpErrorResponseSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  message: z.string(),
  code: z.string(),
});
